import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import { channelOperations } from '../../models/channels';
import { Button, JoinChannelsIcon, JoinedChannelsIcon } from '../ui';
import {
  trackChannelFollow,
  trackChannelUnfollow,
} from '../../models/channels/analytics';
import './channel.scss';
import { useFollowChannelButtonState } from '../../common/channel/use-follow-channel-button-state';
import { ChannelButtonTooltip } from './channel-button-tooltip';

type FollowButtonProps = {
  channelId: string;
  size?: 'small';
  analyticsData: unknown;
};
export const FollowButton = ({
  channelId,
  size = undefined,
  analyticsData,
}: FollowButtonProps) => {
  const dispatch = useDispatch();
  const { label, following, disabled, aria } = useFollowChannelButtonState({
    channelId,
  });

  const className = cx('channel__follow-button', {
    'channel__follow-button--following': following,
    'channel__follow-button--small': size === 'small',
    'pt-theme-bgcolor': !following && size !== 'small',
  });

  const handleClick = useCallback(() => {
    if (!following) {
      dispatch(channelOperations.followChannel(channelId));
      trackChannelFollow(channelId, analyticsData);
    } else {
      dispatch(channelOperations.unfollowChannel(channelId));
      trackChannelUnfollow(channelId, analyticsData);
    }
  }, [analyticsData, channelId, dispatch, following]);

  return (
    <ChannelButtonTooltip channelId={channelId}>
      <Button
        iconComponent={
          following ? <JoinedChannelsIcon /> : <JoinChannelsIcon />
        }
        className={className}
        onClick={handleClick}
        disabled={disabled}
        {...aria}
      >
        <span className="text">{label}</span>
      </Button>
    </ChannelButtonTooltip>
  );
};

export default FollowButton;
